//Variáveis que irão ficar disponíveis de forma global no scope do Vue
import * as momentJS from 'moment'
import Ls from '../helpers/localStorage'
import axios from './services/axios'

Vue.prototype.$momentJS = momentJS
Vue.prototype.$ls = Ls
Vue.prototype.$helpers = HelperJS
Vue.prototype.$axios = axios
